// extracted by mini-css-extract-plugin
export default {"resumeSkillsTitle":"ResumeSkills_resumeSkillsTitle__Aa+XS","skillPillContainer":"ResumeSkills_skillPillContainer__hkpSs","skillPill":"ResumeSkills_skillPill__2Zxp3"};